export const CITIES = [
    {
        slug: "chaumont-en-vexin",
        name: "Chaumont-en-Vexin",
        cp: "60240",
        dept: "Oise",
        km: 0,
        hero: "https://images.unsplash.com/photo-1630699144919-681cf308ae82?q=80&w=1800&auto=format&fit=crop",
        tagline: "Notre commune — le cœur du Vexin français",
        intro:
            "Chaumont-en-Vexin est notre base : c'est ici que Solino Pro est né, et c'est ici que nous avons le plus de chantiers à notre actif. Maisons de bourg, pavillons récents, longères rénovées : nous connaissons les styles de maisons de la commune et les matériaux qui les composent.",
        body:
            "Être basé à Chaumont-en-Vexin, c'est un avantage concret pour vous : déplacement gratuit, visite de chantier rapide, et un artisan qui reste joignable après le chantier. Du centre-bourg aux hameaux environnants, nous intervenons chez vous en quelques jours après votre demande.",
        local: "Nous y réalisons chaque année une dizaine de chantiers : reprises de peinture, changements de sols après dégât des eaux, rénovations complètes avant emménagement.",
    },
    {
        slug: "gisors",
        name: "Gisors",
        cp: "27140",
        dept: "Eure",
        km: 13,
        hero: "https://images.unsplash.com/photo-1597665863042-47e00964d899?q=80&w=1800&auto=format&fit=crop",
        tagline: "Peintre & sols à Gisors — à 15 minutes de notre atelier",
        intro:
            "Ville médiévale au pied de son château, Gisors réunit un centre historique aux maisons anciennes et des quartiers résidentiels plus récents. Deux univers techniques bien différents : on ne prépare pas un mur du XVIIIᵉ comme celui d'un pavillon des années 90.",
        body:
            "Nous intervenons régulièrement à Gisors pour des rénovations intérieures complètes, des reprises de peinture après dépose de papier peint et des poses de parquet dans les maisons de ville. Notre proximité (une quinzaine de minutes) nous permet d'organiser des visites rapides et de suivre le chantier au quotidien.",
        local: "Habitation ancienne du centre-ville : nous vérifions toujours l'état des supports avant peinture — enduits anciens et humidité demandent une préparation spécifique.",
    },
    {
        slug: "meru",
        name: "Méru",
        cp: "60110",
        dept: "Oise",
        km: 11,
        hero: "https://images.unsplash.com/photo-1630699375895-fe5996d163ee?q=80&w=1800&auto=format&fit=crop",
        tagline: "Peintre & revêtement de sol à Méru",
        intro:
            "Méru, célèbre pour son histoire de la nacre et de la tabletterie, est à moins d'un quart d'heure de Chaumont-en-Vexin. Une ville familiale où nous réalisons beaucoup de projets d'actualité : chambres d'enfants, sols remplacés avant une naissance, cuisines rafraîchies.",
        body:
            "Les pavillons de Méru ont souvent leurs sols et peintures d'origine : nous y pratiquons la rénovation d'actualité — remplacement d'une moquette par du vinyle en lames, reprise complète des peintures murs et plafonds. Un chantier type dure deux à quatre jours.",
        local: "Nous intervenons aussi sur les communes voisines : Le Mesnil-en-Thelle, Bornel, Andeville, Litz.",
    },
    {
        slug: "marines",
        name: "Marines",
        cp: "95640",
        dept: "Val-d'Oise",
        km: 15,
        hero: "https://images.unsplash.com/photo-1597665863042-47e00964d899?q=80&w=1800&auto=format&fit=crop",
        tagline: "Peintre & sols à Marines — Val-d'Oise",
        intro:
            "Sous-préfecture du Val-d'Oise, Marines anime le Vexin français de son marché et de ses commerces. À une quinzaine de kilomètres de Chaumont-en-Vexin, c'est l'une de nos destinations naturelles côté Île-de-France.",
        body:
            "À Marines et dans les villages alentour — Bréançon, Villiers-en-Sainton, Jouy-le-Moutier n'est pas loin mais nous restons concentrés sur le plateau du Vexin — nous suivons des chantiers de rafraîchissement complet : peinture générale, remplacement des revêtements de sol, rénovation de salles de bain carrelées.",
        local: "Maisons des années 70-80 : nous remplaçons souvent les sols grès d'époque par du vinyle en lames ou du parquet stratifié.",
    },
    {
        slug: "magny-en-vexin",
        name: "Magny-en-Vexin",
        cp: "95420",
        dept: "Val-d'Oise",
        km: 14,
        hero: "https://images.unsplash.com/photo-1688372199140-cade7ae820fe?q=80&w=1800&auto=format&fit=crop",
        tagline: "Peintre & façades à Magny-en-Vexin",
        intro:
            "Bourg de caractère au bord du plateau du Vexin, Magny-en-Vexin est à une quinzaine de minutes de notre atelier. C'est sur ce secteur que nous menons la majorité de nos chantiers de façades et de finitions murales, sur des maisons qui en valent la peine.",
        body:
            "Maisons de bourg en pierre, maisons de maître, pavillons : le parc immobilier de Magny demande souvent un travail de fond avant la peinture — reprise d'enduits, traitement des fissures, décapage. Nous connaissons les entreprises locales et travaillons volontiers en coordination avec d'autres corps d'état.",
        local: "Avant toute peinture de façade à Magny, nous vérifions la nature du support : pierre meulière et enduit à la chaux demandent des produits respirants.",
    },
    {
        slug: "chars",
        name: "Chars",
        cp: "95750",
        dept: "Val-d'Oise",
        km: 10,
        hero: "https://images.unsplash.com/photo-1562259949-e8e7689d7828?q=80&w=1800&auto=format&fit=crop",
        tagline: "Peintre & sols à Chars — à 10 minutes",
        intro:
            "Chars, sa gare et son bourg historique sont à peine à dix minutes de Chaumont-en-Vexin : c'est l'une des communes les plus proches de notre base, et l'une de celles où nous revenons le plus souvent.",
        body:
            "Nous y réalisons des chantiers de toutes tailles : rafraîchissement d'un couloir, pose de stratifié dans une chambre, reprise complète d'un salon. La proximité rend tout plus simple — passage rapide pour chiffrer, livraison des matériaux sans frais, ajustements faciles en cours de chantier.",
        local: "Vous venez d'acheter à Chars ou dans un village voisin ? Nous enchaînons volontiers sols puis peintures pour que vous emménagiez dans une maison prête.",
    },
    {
        slug: "beauvais",
        name: "Beauvais",
        cp: "60000",
        dept: "Oise",
        km: 30,
        hero: "https://images.unsplash.com/photo-1589010243150-58666d535521?q=80&w=1800&auto=format&fit=crop",
        tagline: "Peintre & revêtement de sol à Beauvais",
        intro:
            "Préfecture de l'Oise, Beauvais est la grande ville de notre zone d'intervention — à une demi-heure de Chaumont-en-Vexin par la départementale. Appartements anciens, maisons de ville, pavillons : le parc y est vaste et les projets nombreux.",
        body:
            "À Beauvais, nous privilégions les projets où notre suivi local fait la différence : rénovations complètes, chantiers de sols importants, repeintes de façades en centre-ville. Nous nous y déplaçons pour des chantiers supérieurs à une pièce, avec le même devis sous 48 h qu'ailleurs.",
        local: "Appartements anciens du centre : nous sommes équipés pour la pose de parquet sur anciens planchers et la reprise des plinthes et moulures.",
    },
    {
        slug: "pontoise",
        name: "Pontoise",
        cp: "95000",
        dept: "Val-d'Oise",
        km: 30,
        hero: "https://images.unsplash.com/photo-1597665863042-47e00964d899?q=80&w=1800&auto=format&fit=crop",
        tagline: "Peintre & sols à Pontoise — Val-d'Oise",
        intro:
            "Ville d'art immortalisée par Pissarro, Pontoise ferme notre zone au sud, à une demi-heure de notre atelier. Maisons de ville en coteau, appartements avec charme, pavillons des communes limitrophes : la ville offre une belle diversité de projets.",
        body:
            "Nous intervenons à Pontoise et dans ses communes voisines (Cergy, Saint-Ouen-l'Aumône, Osny) sur des chantiers sélectionnés : rénovation de sols et peintures complètes. Comme partout, vous recevez votre devis sous 48 h et un interlocuteur unique du devis à la réception.",
        local: "Maisons en coteau : attention aux remontées d'humidité, nous diagnostiquons le support avant de peindre et vous orientons vers un traitement si nécessaire.",
    },
];

export const cityBySlug = (slug) => CITIES.find((c) => c.slug === slug);
